import(/* webpackMode: "eager", webpackExports: ["default"] */ "/srv/gentletales/next-app/components/ClientApp.tsx");
